import React, { Component } from 'react';
import Layout from '../../../Layouts/DefaultLayout';
import * as PostActions from '../../../../redux/post/actions';
import { Breadcrumb, Row, Col, Container, Image, Form, Button, Spinner, Card } from 'react-bootstrap';
import * as BMOActions from '../../../../redux/bmos/actions';
import OtherOfferingsCarousel from '../../../Layouts/Partials/OtherOfferingsCarousel';
import ResourcesCarousel from '../../../Layouts/Partials/ResourcesCarousel';
import ExploreOperators from '../../../Layouts/Partials/ExploreOperators';
import _ from 'lodash'

class ResourceBMOViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {
            data: null,
            isLoading: false,
            data_allOfferings: [],
            data_allResources: [],
            msg: ""
        }
    }

    componentDidMount = async () => {
        let slug = this.props.match.params.id;
        if (slug !== undefined) {
            this._loadBMO(slug);
        } else {
            this.backToList();
        }

    }


    shouldComponentUpdate(nextProps, nextState) {

        return true;
    }

    _loadBMO = async (slug) => {
        this.setState({ isLoading: true });
        let resp = await BMOActions.searchBMOJson(this.props.token, slug);
        if (resp.state) {
            this.setState({ isLoading: false, data: resp.data }, () => {
                this._handleAllOfferingsByBMO(resp.data['term_id'])
            });
        } else {
            this.setState({ isLoading: false }, () => this.backToList());
        }
    }

    _handleAllOfferingsByBMO = async (bmo) => {

        this.setState({ isLoading: true }, () => this._handleAllResourcesByBMO(bmo));

        let reqobj = {};
        reqobj['env'] = process.env.REACT_APP_MODE;
        reqobj['posts_per_page'] = 4;
        reqobj['post-type'] = 'offering';
        reqobj['bmos'] = [bmo];
        let resp = await PostActions.getAnyPostsJSON(this.props.token, 1, reqobj);
        if (resp.status) {
            this.setState({ data_allOfferings: resp.data.data }, () => {
                this.setState({ isLoading: false })
            });
        } else {
            this.setState({ isLoading: false })
        }

    }
    _handleAllResourcesByBMO = async (bmo) => {

        this.setState({ isLoading: true });

        let reqobj = {};
        reqobj['env'] = process.env.REACT_APP_MODE;
        reqobj['posts_per_page'] = 4;
        reqobj['post-type'] = 'post';
        reqobj['bmos'] = [bmo];
        let resp = await PostActions.getAnyPostsJSON(this.props.token, 1, reqobj);
        if (resp.status) {
            this.setState({ data_allResources: resp.data.data }, () => {
                this.setState({ isLoading: false })
            });
        } else {
            this.setState({ isLoading: false })
        }

    }

    backToList = () => {
        this.props.history.push(`/operators`);
    }

    _submitMailToBMO = async (e, bmoid) => {
        e.preventDefault();
        if (this.state.msg !== "") {
            this.setState({ isLoading: true });
            const formdata = {
                "sender-mail": this.props.usermail,
                "bmoid": bmoid,
                "msg": this.state.msg
            }
            const resp = await BMOActions.sendMailToBMOJson(this.props.token, formdata);
            this.setState({ isLoading: false, msg: "" });
        }
    }

    render = () => {
        const operator = this.state.data;
        return (
            <Layout >
                {(operator !== null) && (
                    <React.Fragment>
                        <Container>
                            <Breadcrumb className="mt-4">
                                <Breadcrumb.Item href="/resources">{`Resources`}</Breadcrumb.Item>
                                <Breadcrumb.Item href={`/resources/${operator.slug}`}>{`${operator.slug}`}</Breadcrumb.Item>
                            </Breadcrumb>
                            <h1>{operator.name}</h1>
                        </Container>
                        
                

                    
                        {/*  //sample https://coreui.io/docs/components/bootstrap/card/
                        <div class="card mb-3" style={{maxWidth:'540px'}}>
                        <div class="row no-gutters">
                            <div class="col-md-4">
                                <img src={"../assets/images/AVATAR.png"} class="card-img" style={{width:'80%'}} alt="..."/>

                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title">Card title</h5>
                                <p class="card-text">It's a broader card with text below as a natural lead-in to extra content. This content is a little longer.
                                It's a broader card with text below as a natural lead-in to extra content. This content is a little longer.
                                </p>
                                <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                            </div>
                            </div>
                        </div>
                        </div>
                        */}

                   
                   {/*  img-left and content-right using bootstrap css */}
                   {/*
                    <br/><br/><br/><br/><br/><br/><br/><br/>
                    <div className="row">
                        <div className="col-md-3"></div>
                        <div className="col-md-6">
                            <div class="card mb-3">
                            <div class="row no-gutters">
                                <div class="col-md-4 card-img">
                                    <div className="row">
                                        <div className="col-md-2"></div>
                                        <div className="col-md-10"><img src={"../assets/images/AVATAR.png"} class="card-img" style={{width:'80%'}} alt="..."/></div>
                                    </div>
                                    
                                </div>
                                <div class="col-md-8">
                                    <div class="card-body" style={{paddingTop:'8%'}}>
                                        <div className="row col-md-12" >
                                            <div className="col-md-3 font-weight-bold card-text">Name</div>
                                            <div className="col-md-9 card-text">{operator.acf.expert_first_name.value} {operator.acf.expert_last_name.value}</div>
                                        </div>
                                        <div className="row col-md-12" >
                                            <div className="col-md-3 font-weight-bold card-text">Email</div>
                                            <div className="col-md-9 card-text">{operator.acf.email.value}</div>
                                        </div>
                                        <div className="row col-md-12" >
                                            <div className="col-md-3 font-weight-bold card-text">Phone</div>
                                            <div className="col-md-9 card-text">{operator.acf.expert_phone.value}</div>
                                        </div>
                                        <div className="row col-md-12" >
                                            <div className="col-md-3 font-weight-bold card-text">Website</div>
                                            <div className="col-md-9 card-text"><a target="_blank" href={operator.acf.website.value}>{operator.acf.website.value}</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                            </div>
                            <div className="col-md-3"></div>
                        </div>
                        <br/><br/><br/><br/><br/><br/><br/><br/> 
                        */}
                    {/*  img-left and content-right using bootstrap css */}
                        


<br/><br/><br/><br/>   
<div className="row" >
    <div className="col-md-3"></div>
    <div className="col-md-6">
        <div /*style={{paddingLeft:'25%'}}*/>
            <Card style={{ /*width: '18rem',*/ display: 'flex', flexDirection: 'row'}}>
                <Card.Img style={{width:'36%'}} variant="top" src={"../assets/images/AVATAR.png"} />
                
                <Card.Body style={{backgroundColor:'#fff',backgroundClip:'border-box',border:'1px solid rgba(0,0,0,.125)',borderRadius:'.25rem',textAlign:"left"}} /*style={{border:'1px solid rgba(0,0,0,.125);',backgroundColor:'#fff'}}*/>
                    <Card.Text style={{paddingTop:'15%'}}><strong>Name:</strong>{operator.acf.expert_first_name.value} {operator.acf.expert_last_name.value}</Card.Text>
                    <Card.Text>
                    <strong>Email:</strong>{operator.acf.email.value}
                    </Card.Text>
                    {(operator.acf.expert_phone !== undefined) && (
                    <Card.Text>
                        <strong>Phone:</strong>{operator.acf.expert_phone.value}
                    </Card.Text>
                    )}
                    <Card.Text>
                    <strong>Website:</strong><a target="_blank" href={operator.acf.website.value}>{operator.acf.website.value}</a>
                    </Card.Text>
                    
                </Card.Body>
            </Card>
        </div>
    </div>
    <div className="col-md-3"></div>
</div>
<br/><br/><br/><br/><br/><br/><br/><br/><br/>

                {/*  bootstrap-react- card*/}
                {/*
                <br/><br/><br/><br/>   
                <div className="row" >
                    <div className="col-md-4"></div>
                    <div className="col-md-4 text-center">
                        <div style={{paddingLeft:'25%'}}>
                            <Card style={{ width: '18rem'}}>
                            <Card.Img variant="top" src={"../assets/images/AVATAR.png"} />
                            
                            <Card.Body>
                                <Card.Title><b>{operator.acf.expert_first_name.value} {operator.acf.expert_last_name.value}</b></Card.Title>
                                <Card.Text>
                                    {operator.acf.email.value}
                                </Card.Text>
                                {(operator.acf.expert_phone !== undefined) && (
                                <Card.Text>
                                    {operator.acf.expert_phone.value}
                                </Card.Text>
                                )}
                                <Card.Text>
                                    <a target="_blank" href={operator.acf.website.value}>{operator.acf.website.value}</a>
                                </Card.Text>
                                
                            </Card.Body>
                            </Card>
                        </div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
                <br/><br/><br/><br/>   
                                */}
                 {/* bootstrap-react- card*/}
            

            {/*  bootstrap css - card display */}
            {/*
            <div className="text-left" >
                <h3 className="text-center">Contact Details</h3>
               
                <div className="row" >
                    <div className="col-md-4"></div>
                    <div className="col-md-4" style={{border:"1px solid gray"}}>
                        <div><img src="./assets/images/AVATAR.png" width="100%" className="mb-4" /></div>
                        <div style={{fontWeight:"bold"}}>Name:{operator.acf.expert_first_name.value} {operator.acf.expert_last_name.value}</div>
                        <div><b>Website: </b><a target="_blank" href={operator.acf.website.value}>{operator.acf.website.value}</a></div>
                        <div><b>Contact: </b>{operator.acf.expert_phone.value}</div>
                        <div><b>Email: </b>{operator.acf.email.value}</div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            </div>
            <br/>
            */}

            {/* bootstrap div*/}
            {/*
            <div className="text-left">
                <h3 className="text-left">Contact Details</h3>
                <row >
                    <Col className="col-md-2"></Col>
                    <Col className="col-md-8">
                        <div><b>Name: </b>{operator.acf.expert_first_name.value} {operator.acf.expert_last_name.value}</div>
                        <div><b>Website: </b><a target="_blank" href={operator.acf.website.value}>{operator.acf.website.value}</a></div>
                        <div><b>Contact: </b>{operator.acf.expert_phone.value}</div>
                        <div><b>Email: </b>{operator.acf.email.value}</div>
                    </Col>
                    <Col className="col-md-2"></Col>
                </row>
            </div>
            <br/>
            */}
            
            </React.Fragment>
            )}
            </Layout>
        );
    };



}


/* Export Component ==================================================================== */
export default ResourceBMOViewContainer;